import { PromotionSettingList } from './PromotionSettingList'
import { withPromotionSettingList } from './withPromotionSettingList'

const ConnectedPromotionSettingList =
  withPromotionSettingList(PromotionSettingList)

export { ConnectedPromotionSettingList as PromotionSettingList }
